import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { motion } from 'framer-motion';
import { Building2, FileSpreadsheet, Receipt, ShieldCheck, Globe2, Banknote, Database } from 'lucide-react';
const POMELO = '#86efac'; // emerald-300 — close to Pomelo mint
export function IntegrationsLayer() {
  const thirdPartyData = [{
    icon: Building2,
    title: 'Business Registry',
    vendor: 'ACRA / Local Registries',
    signals: ['UEN verification & entity status', 'Directors, shareholders, registered address', 'Date of incorporation (business age proxy)', 'Filing compliance status'],
    color: 'bg-indigo-50 text-indigo-600'
  }, {
    icon: FileSpreadsheet,
    title: 'Accounting Platforms',
    vendor: 'Xero, QuickBooks, MYOB',
    signals: ['Profit & loss statements', 'Balance sheet snapshots', 'Outstanding receivables / payables', 'Tax filings & GST submissions'],
    color: 'bg-blue-50 text-blue-600'
  }, {
    icon: Receipt,
    title: 'E-Invoicing & Payroll',
    vendor: 'InvoiceNow, Talenox, Payboy',
    signals: ['B2B receivables pipeline', 'Headcount and salary obligations', 'Payment runs and supplier liabilities'],
    color: 'bg-teal-50 text-teal-600'
  }, {
    icon: ShieldCheck,
    title: 'Credit Bureaus',
    vendor: 'CBS, Experian, Dun & Bradstreet',
    signals: ['Director personal credit scores', 'Existing facility utilisation', 'Default & bankruptcy records', 'Inquiry velocity (other applications)'],
    color: 'bg-amber-50 text-amber-600'
  }, {
    icon: Globe2,
    title: 'KYB / Sanctions',
    vendor: 'ComplyAdvantage, Sumsub',
    signals: ['PEP & sanctions screening', 'Adverse media monitoring', 'Beneficial ownership chains', 'Ongoing AML risk scoring'],
    color: 'bg-red-50 text-red-600'
  }, {
    icon: Banknote,
    title: 'Open Banking',
    vendor: 'SGFinDex, Plaid, TrueLayer',
    signals: ['External bank account balances', 'Non-PSP revenue flows', 'Loan obligations & repayment history', 'Cash runway across all accounts'],
    color: 'bg-emerald-50 text-emerald-600'
  }];
  return <SectionWrapper title="Third-Party Data Integrations" subtitle="Pomelo's PSP data is the primary signal — but external data sources sharpen credit decisions, satisfy regulatory KYB requirements, and reduce false positives in the scorecard." data-id="element-71">
      {/* Third-party data */}
      <div data-id="element-72">
        <div className="flex items-center gap-2 mb-6" data-id="element-73">
          <Database className="w-5 h-5 text-emerald-600" data-id="element-74" />
          <h2 className="text-xl font-semibold text-slate-900" data-id="element-75">
            Third-Party Data Sources
          </h2>
        </div>
        <p className="text-slate-600 mb-6 max-w-3xl leading-relaxed" data-id="element-76">
          These data points augment PSP signals to reduce false positives,
          accelerate approvals, and meet bank credit policy requirements that go
          beyond cashflow alone.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-77">
          {thirdPartyData.map((source, i) => {
          const Icon = source.icon;
          return <motion.div key={source.title} initial={{
            opacity: 0,
            y: 15
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: i * 0.05
          }} className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm hover:border-emerald-300 hover:shadow-md transition-all" data-id="element-78">
                <div className="flex items-start gap-3 mb-3" data-id="element-79">
                  <div className={`p-2 rounded-lg ${source.color}`} data-id="element-80">
                    <Icon className="w-5 h-5" data-id="element-81" />
                  </div>
                  <div data-id="element-82">
                    <h3 className="font-semibold text-slate-900 text-sm" data-id="element-83">
                      {source.title}
                    </h3>
                    <p className="text-xs text-slate-500 mt-0.5" data-id="element-84">
                      {source.vendor}
                    </p>
                  </div>
                </div>
                <ul className="space-y-1.5 mt-3 pl-1" data-id="element-85">
                  {source.signals.map((s, idx) => <li key={idx} className="flex items-start gap-2 text-xs text-slate-600" data-id="element-86">
                      <div className="w-1 h-1 rounded-full bg-slate-300 mt-1.5 flex-shrink-0" data-id="element-87" />
                      <span className="leading-relaxed" data-id="element-88">{s}</span>
                    </li>)}
                </ul>
              </motion.div>;
        })}
        </div>
      </div>
    </SectionWrapper>;
}